module.exports = __webpack_public_path__ + "static/media/  (44).12127311.jpg";